// this is an autogenerated file from App/Account/Content/Tasks/New/Menu/Expanded/BoardsList/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_Menu_Expanded_BoardsList($location_id: uuid!) {
  tasks_boards(
    where: {
      status: { _eq: active }
      metadata: { _contains: { locations: [$location_id] } }
    }
    order_by: { name: asc }
  ) {
    id
    name
    metadata

    stages(order_by: [{ order: asc }], limit: 1) {
      id
      tasks_aggregate {
        aggregate {
          count
        }
      }
    }
  }
}

`